module.exports = __webpack_public_path__ + "static/media/ui.93f9893e.svg";